import React from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getImgSrc } from '../../../services/common/CommonUtils';
import { getGlobalSettingValue,isContainAlphabet } from '../../../services/common/utils';
export default function UsageList({ listItem,count }) {
    if (listItem.length === 1) {
        return (
            <>
                <div className={`usage_list_1col w-100`}>
                    <div className="usage_box w-100">
                        <UsageContent data={listItem[0]} />
                    </div>
                </div>
                <div class="hr-sm pt-2"></div>
            </>
        )
    }


    if (listItem.length === 2) {
        return (
            <>
                <div className={`usage_list_2col w-100`}>
                    <div className="usage_box w-100">
                        <UsageContent data={listItem[0]} />
                    </div>
                    <div class="vr-sm"></div>
                    <div className="usage_box w-100">
                        <UsageContent data={listItem[1]} />
                    </div>
                </div>
                
               <div class="hr-sm pt-2"></div>
                
            </>
        )
    }

    if (listItem.length === 3) {
        return (
            <>
                <div className="usage_list_3col w-100">
                    <div className="usage_box child1">
                        <UsageContent data={listItem[0]} />
                    </div>
                    <div class="vr-sm"></div>
                    <div className="usage_box child2">
                        <UsageContent data={listItem[1]} />
                    </div>
                    <div class="vr-sm"></div>
                    <div className="usage_box child3">
                        <UsageContent data={listItem[2]} />
                    </div>
                </div>
                <div class="hr-sm pt-2"></div>
            </>
        )
    }

    return null
}

function UsageContent({ data }) {
    const { t } = useTranslation();
    const {
        utilityData: { globalSetting },
    } = useSelector((state) => state);
    const settingsArr = globalSetting
        ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
        : [];

    const getColorCode = (percentage) => {
        if (percentage > getGlobalSettingValue('dashboardhighpercentage', settingsArr)) {
            return getGlobalSettingValue('dashboardhighcolor', settingsArr);
        } else if (percentage > getGlobalSettingValue('dashboardmediumpercentage', settingsArr)) {
            return getGlobalSettingValue('dashboardmediumcolor', settingsArr);
        } else {
            return getGlobalSettingValue('dashboardlowcolor', settingsArr);
        }
    }

    const showNotaion = data?.rnnotation && data?.rnnotation !== 'Bytes' && data?.rnnotation !== 'Min';
    const used = showNotaion ? data?.balance : `${data?.balance + ' ' + data?.notation}`;
    const total = '';
    // showNotaion ? data?.total : `${data?.total + ' ' + (data?.totalnotation || data?.notation)}`;

    return (
        <>
            <div className="usage_box_info">
                <div className="usage_value"> {data?.rndsheader} </div>

                {
                    data?.isunlimited && data?.rnlabel?.length === 0 ? (
                        <div className="usage_label">
                            <img src={getImgSrc("/assets/images/dashboardunlimited.svg")}></img>
                        </div>
                    ) : (
                        <div className="usage_label" style={{"direction":isContainAlphabet(used) ? "ltr" :""}} >{used} <span> {`${total ? `/ ${total}` : ''}`} </span></div>
                    )
                }

            </div>

            <div className="usage_box_slider">
                {
                    data?.isunlimited && data?.rnlabel?.length === 0 ? (
                        <p> {t('unlimited')} </p>
                    ) : (
                        <div className="progress" role="progressbar">
                            <div className="progress-bar" style={{ width: `${parseFloat(data?.percentage)}%` || '0%', backgroundColor: getColorCode(parseFloat(data?.percentage) || 0) }}></div>
                        </div>
                    )
                }
            </div>

            {
                data?.isunlimited && data?.rnlabel?.length !== 0 && (
                    <div class="sprint14-sup-text w-100">
                        <img src={getImgSrc("/assets/images/dashboardunlimited.svg")} /> {data?.rnlabel}
                    </div>
                )
            }
        </>
    )
}